import { getColumnsByNames, } from './all-top10-columns-config';

export const topListHits = getColumnsByNames([
    { name: 'src' },
    { name: 'dst' },
    { name: 'rule' },
    { name: 'count', width: '29%' } 
]);